module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-column"
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-column"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.uid))])]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-file",
      attrs: {
        "accept": ".yaml",
        "name": "file",
        "show-file-list": false,
        "action": _vm.$util.aioIP + '/api/m/sys/config/file/v365/upload',
        "headers": {
          channelCode: _vm.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj'
        },
        "data": {
          schoolId: _vm.schoolId,
          uid: item.uid,
          userName: _vm.$store.state.user.name
        },
        "on-success": _vm.handleSuccess,
        "on-error": _vm.handleError
      }
    }, [_c('el-button', [_vm._v("选择上传文件")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-around"
    }, [_c('span', [_vm._v(_vm._s(item.fileName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.createTime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.uploader))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-between"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.clickDownload(item)
        }
      }
    }, [_vm._v("下载")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.clickUploadConfigRecord(item)
        }
      }
    }, [_vm._v("查看上传记录")])], 1), _vm._v(" "), _c('div', {
      staticClass: "sperate-line"
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f40a573!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/UniversityManage/CollegeManage/Components/HardwareConfig.vue
// module id = 1044
// module chunks = 0